import { useTheme } from "next-themes";
import logoLight from "@/assets/enviroeng_logo_primary_light.png.asset.json";
import logoDark from "@/assets/enviroeng_logo_dark.png.asset.json";
import logoMono from "@/assets/enviroeng_logo_monochrome.png.asset.json";
import iconMark from "@/assets/enviroeng_icon_mark.png.asset.json";
import iconNavyGold from "@/assets/enviroeng_icon_navy_gold.png.asset.json";
import iconDarkTeal from "@/assets/enviroeng_icon_dark_teal.png.asset.json";

export const LOGO_ASSETS = {
  fullLight: logoLight.url,
  fullDark: logoDark.url,
  mono: logoMono.url,
  iconMark: iconMark.url,
  iconNavyGold: iconNavyGold.url,
  iconDarkTeal: iconDarkTeal.url,
} as const;

type Variant = "full" | "icon" | "mono";

interface LogoProps {
  variant?: Variant;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
  alt?: string;
}

export default function Logo({
  variant = "full",
  className,
  width,
  height,
  priority = false,
  alt = "EnviroEng Pro",
}: LogoProps) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  let src: string;
  let w = width;
  let h = height;

  if (variant === "mono") {
    src = LOGO_ASSETS.mono;
    w ??= 320;
    h ??= 96;
  } else if (variant === "icon") {
    src = isDark ? LOGO_ASSETS.iconDarkTeal : LOGO_ASSETS.iconMark;
    w ??= 128;
    h ??= 128;
  } else {
    src = isDark ? LOGO_ASSETS.fullDark : LOGO_ASSETS.fullLight;
    w ??= 320;
    h ??= 96;
  }

  return (
    <img
      src={src}
      alt={alt}
      width={w}
      height={h}
      className={className}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      loading={priority ? "eager" : "lazy"}
    />
  );
}
